import { useCallback } from "react";

import { MONOLITH_ORIGIN } from "@/monolithIntegration/monolithIntegration.constants";
import useRestMutation from "@/remoteState/useRestMutation";

const useGuidedHighlightingGetAnswers = () => {
  const createEventRecordRequest = useCallback(
    (params: { articleId: string }) => {
      const articleId = params.articleId;
      const requestUrl = `${MONOLITH_ORIGIN}/api/v3/annotations/?content_id=${articleId}`;
      const requestConfig = {
        method: "GET",
        headers: { "Content-Type": "application/json" },
      };
      return new Request(requestUrl, requestConfig);
    },
    [],
  );
  return useRestMutation(createEventRecordRequest);
};

export default useGuidedHighlightingGetAnswers;
